import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1,
    },
    balance: []
}

export function withdrawalsAwaitingReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_CARD_OPERATION:
            return { ...state, list: action.payload};
        case types.SET_GET_ALFAKIT_BALANCE:
            return { ...state, balance: action.payload };
        default:
            return state
    }
}